import { ExtraOptions, RouterModule, Routes, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { NgModule, Injectable } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthenticationGuard } from './ff/guards/authentication.guard';
import { LoginComponent } from './authentication/login/login.component';
import { NotFoundComponent } from './pages/miscellaneous/not-found/not-found.component';

import { AuthenticationService } from './ff/services/authentication/authentication.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DataResolver implements Resolve<any> {
  constructor(private authentication_service: AuthenticationService) {}
  // We need to resolve the current user for routing to run (i.e. we can't do auth guards if we don't know this)
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any>|Promise<any>|any {
    return this.authentication_service.get_current_user();
  }
}

const routes: Routes = [
  {
    path: 'application/portal',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
    canActivate: [AuthenticationGuard], // Guard redirects to /auth if not logged in!,
    resolve: {
      data: DataResolver,
    },
  },
  {
    path: 'application/authentication',
    loadChildren: () => import('./authentication/authentication.module')
      .then(m => m.AuthenticationModule),
    // children: [
    //   {
    //     path: '',
    //     component: LoginComponent,
    //   },
    //   {
    //     path: 'login',
    //     component: LoginComponent,
    //   },
      // {
      //   path: 'register',
      //   component: NbRegisterComponent,
      // },
      // {
      //   path: 'logout',
      //   component: NbLogoutComponent,
      // },
      // {
      //   path: 'request-password',
      //   component: NbRequestPasswordComponent,
      // },
      // {
      //   path: 'reset-password',
      //   component: NbResetPasswordComponent,
      // },
    // ],
  },
  // { path: 'html/json/menu/data.j!importantson', redirectTo: 'assets/data/menu_data.json'},
  { path: '', redirectTo: 'application/portal', pathMatch: 'full' },
  { path: '**', redirectTo: 'application/portal' },
];

const config: ExtraOptions = {
  useHash: false,
  onSameUrlNavigation: 'reload',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
  providers: [DataResolver],
})
export class AppRoutingModule {
}
